<template>

  <PageHero v-if="agency" :agency="agency"
    :title="$t('hero.title_agency') + '     ' + agency.name"
    :breadcrumbsTop="[
      { label: $t('hero.breadcrumbs.home'), link: '/' },
      { label: $t('hero.breadcrumbs.agencies') }
    ]"
  />
    <div class="container py-10">
      <h1 class="text-2xl fw-semibold mb-4"></h1>
      <MiniFilterBar @update="onFilterUpdate" />
        <h1 class="text-2xl fw-semibold mb-4"></h1>
        

      <AgencyProperties v-if="agency && agency.id" :agency-id="agency.id" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AgencyHero from '../pages/agency_detail/AgencyHero.vue'
import AgencyProperties from '../pages/AgencyProperties.vue' // ✅ добавь импорт
import PageHero from '../components/PageHero.vue'
import MiniFilterBar from '../components/MiniFilterBar.vue'


const agency = ref(null)

onMounted(async () => {
  try {
    const pathParts = window.location.pathname.split('/')
    const id = pathParts[pathParts.length - 1]

    const response = await fetch(`/api/v1/agencies/${id}.json`)
    const data = await response.json()
    agency.value = data
  } catch (error) {
    console.error('Ошибка загрузки квартиры:', error)
  }
})
</script>